var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEmail48Line = function SvgIconEmail48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 11.3H14.6a5.3 5.3 0 0 0-5.3 5.3v14.8a5.3 5.3 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V16.6a5.3 5.3 0 0 0-5.3-5.3Zm-.9 3.4L24 21.78l-8.51-7.08H32.5Zm.9 18.6H14.6a1.9 1.9 0 0 1-1.9-1.9V16.79l9.44 7.87a2.9 2.9 0 0 0 3.71 0l9.45-7.87V31.4a1.91 1.91 0 0 1-1.9 1.9Z",
    fill: "current"
  })));
};
export default SvgIconEmail48Line;